module.exports = __webpack_public_path__ + "img/exam_jan_2025_2ywmn1qu.078619ea.jpg";